// 🔧 ticket_generator.js
// ✅ Purpose: Generates Ticket Engine demo data
// ✅ Features:
// - Generates ticket types
// - Generates demo ticket purchases / ticket holders
// - Scales ticket holder count by demo size
// - No Firestore writes
// - No DemoContext mutation
// - Fully block-commented for clarity and future devs

import { buildTicketDefaults } from "./templates/ticket_defaults";

export const generateTickets = ({ demoContext } = {}) => {
  console.log("🎫 Ticket Generator started.");

  const industryTemplate =
    demoContext?.industryTemplate?.key ||
    demoContext?.demoConfig?.industry ||
    "car_show";

  const demoSize =
    demoContext?.demoConfig?.size ||
    demoContext?.seedProfile?.demoSize ||
    "medium";

  const ticketData = buildTicketDefaults({
    industryTemplate,
    demoSize,
  });

  console.log("✅ Ticket Generator completed.", {
    ticketTypes: ticketData.ticketTypes.length,
    tickets: ticketData.tickets.length,
    industryTemplate,
    demoSize,
  });

  return ticketData;
};
